// Single source of truth for backend URLs.
// Override locally with VITE_API_BASE / VITE_WS_URL when running `vite dev`.
const env = import.meta.env || {};

export const API_BASE = env.VITE_API_BASE || "https://api-expansao.isap.eng.br";
export const WS_URL = env.VITE_WS_URL || "wss://api-expansao.isap.eng.br/sync";

export const STORAGE_KEY = "wcrm-kanban-state-v1";
export const AUTH_KEY = "wcrm-kanban-auth-v1";

export const DEFAULT_FUNNEL_ID = "atendimento";
export const DEFAULT_STAGES = [
  { id: "novo", title: "Novo", color: "#128c7e", isWon: false, isLost: false },
  { id: "contato", title: "Contato", color: "#2563eb", isWon: false, isLost: false },
  { id: "proposta", title: "Proposta", color: "#f0b429", isWon: false, isLost: false },
  { id: "negociacao", title: "Negociacao", color: "#7c3aed", isWon: false, isLost: false },
  { id: "ganho", title: "Ganho", color: "#16a34a", isWon: true, isLost: false },
  { id: "perdido", title: "Perdido", color: "#c2410c", isWon: false, isLost: true },
];
export const DEFAULT_FUNNELS = [
  { id: DEFAULT_FUNNEL_ID, title: "Atendimento", stages: DEFAULT_STAGES.map((s) => ({ ...s })) },
];
export const STAGE_COLORS = ["#128c7e", "#2563eb", "#f0b429", "#7c3aed", "#16a34a", "#c2410c", "#0f766e", "#db2777"];

export const TEMPLATES = [
  { id: "primeiro", title: "Primeiro contato", text: "Oi, {{nome}}. Tudo bem? Vi seu interesse em {{curso}} e queria te ajudar com os proximos passos." },
  { id: "retorno", title: "Retorno", text: "Oi, {{nome}}. Passando para retomar nosso atendimento. Posso te ajudar agora?" },
  { id: "proposta", title: "Proposta", text: "Oi, {{nome}}. Separei as informacoes sobre {{curso}}. O investimento fica em {{valor}}. Quer que eu te envie os detalhes?" },
  { id: "followup", title: "Follow-up", text: "Oi, {{nome}}. Conseguiu analisar? Posso tirar alguma duvida para voce finalizar?" },
];
